import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PersonDetail, PersonRelationInfo } from 'src/app/admin-api';
import { TableColumn } from '../table';

@Component({
  selector: 'app-person-invites',
  templateUrl: './person-invites.component.html',
  styleUrls: ['./person-invites.component.scss'],
  providers: [DatePipe]
})
export class PersonInvitesComponent {
  @Input()
  person: PersonDetail | undefined;

  @Input()
  invites: Array<PersonRelationInfo> | undefined;

  @Input()
  isMobile?: boolean;

  colsReceived: Array<TableColumn> = [
    new TableColumn(
      'De quem',
      'inviterName',
      false,
      'text',
      '/users/person/',
      'personId1'
    ),
    new TableColumn('Relação', 'personRelationType', false),
    new TableColumn('Plano', 'subscriptionTypeName', false),
    this.mgmStatusColumn(),
    new TableColumn('Criação', 'dateCreated', false, 'date')
  ];

  colsSent: Array<TableColumn> = [
    new TableColumn(
      'Para quem',
      'name',
      false,
      'text',
      '/users/person/',
      'personId2'
    ),
    new TableColumn('Relação', 'personRelationType', false),
    new TableColumn('Plano', 'subscriptionTypeName', false),
    this.mgmStatusColumn(),
    new TableColumn('Criação', 'dateCreated', false, 'date')
  ];

  get invitesSent(): Array<PersonRelationInfo> {
    return (
      this.invites?.filter((i) => i.personId1 === this.person?.personId) || []
    );
  }

  get invitesReceived(): Array<PersonRelationInfo> {
    return (
      this.invites?.filter((i) => i.personId2 === this.person?.personId) || []
    );
  }

  private mgmStatusColumn(): TableColumn {
    return new TableColumn.Builder()
      .setHeader('Status MGM')
      .setField('mgmStatusLabel')
      .setFilter(false)
      .setTooltip((invite: PersonRelationInfo) => this.mgmStatusTooltip(invite))
      .build();
  }

  private mgmStatusTooltip(invite: PersonRelationInfo): string {
    const details: string[] = [];

    if (invite.mgmActionTypeLabel) {
      details.push(`Evento: ${invite.mgmActionTypeLabel}`);
    }
    if (invite.mgmPlanCategory) {
      details.push(`Plano MGM: ${invite.mgmPlanCategory}`);
    }
    if (invite.mgmCountsForLadder != null) {
      details.push(`Conta escada: ${invite.mgmCountsForLadder ? 'Sim' : 'Não'}`);
    }
    if (invite.mgmCountsForMarco0 != null) {
      details.push(`Conta marco 0: ${invite.mgmCountsForMarco0 ? 'Sim' : 'Não'}`);
    }
    if (invite.mgmRevertReason) {
      details.push(`Motivo reversão: ${invite.mgmRevertReason}`);
    }

    return details.join(' · ');
  }
}
